module.exports = __webpack_public_path__ + "static/media/2019-06-22.e0df3696.md";